import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseScrollDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMouseScrollDown"><Path fillRule="evenodd" clipRule="evenodd" d="M8.72265 18.6132L12 20.7981L15.2774 18.6132L16.3868 20.2773L12 23.2019L7.61325 20.2773L8.72265 18.6132Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V7ZM13 5H11V9H13V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMouseScrollDown;
